export default __webpack_public_path__ + "static/media/pickuponly_active.2788ffa1.svg";